<template>
  <main v-if="showPage && !paymentEmpty" class="">
    <!-- <section style="height:99.7vh;"> -->
    <!-- projects slider section -->
    <VueSlickCarousel v-bind="settings" class="">
      <div v-for="(project, i) in allprojects" :key="i">
        <Veripay
          v-if="project == 'veripay'"
          :projectName="project"
          :projectColors="projectColors(i)"
          :paymentData="projectPayments(project)"
        />
        <Revotax
          v-else
          :projectName="project"
          :projectColors="projectColors(i)"
          :paymentData="projectPayments(project)"
        />
      </div>
    </VueSlickCarousel>
    <!-- </section> -->
    <!-- footer marquee -->
    <Marquee :marqueeData="marqueeData" />
  </main>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import VueSlickCarousel from "vue-slick-carousel";
import "vue-slick-carousel/dist/vue-slick-carousel.css";
// optional style for arrows & dots
import "vue-slick-carousel/dist/vue-slick-carousel-theme.css";
import Veripay from "@/components/Payments/Veripay.vue";
import Revotax from "@/components/Payments/Revotax.vue";
import Marquee from "@/components/Payments/Marquee.vue";

export default {
  name: "Payments",
  components: {
    VueSlickCarousel,
    Veripay,
    Revotax,
    Marquee,
  },
  computed: {
    ...mapGetters([
      "showPage",
      "paymentEmpty",
      "projectPayments",
      "allprojects",
      "marqueeData",
      "projectColors",
    ]),
  },
  data() {
    return {
      projectName: null,
      // showPage: false,
      settings: {
        arrows: false,
        dots: false,
        focusOnSelect: false,
        infinite: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true,
        speed: 1000,
        pauseOnFocus: false,
        pauseOnHover: false,
        // autoplaySpeed: 1000,
        autoplaySpeed: 1000 * 10,
        cssEase: "linear",
      },
    };
  },
  mounted() {
    // this.getRevotax();
  },
  methods: {
    ...mapActions(["getRevotax"]),
  },
};
</script>
